<template>
  <section>
    <HeadingSmall>
      {{ $options.title }}
    </HeadingSmall>
    <ul class="jc-clearlist">
      <li>
        <InputNumberInline
          v-model="minLength"
          name="minimum length"
          rules="integer|required|between: 1, 64"
          textAfter="characters"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { HeadingSmall, InputNumberInline } from '@jumpcloud/ui-components';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const title = 'Password Minimum Length';

export default {
  name: 'FieldsPasswordMinLength',

  components: {
    HeadingSmall,
    InputNumberInline,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    minLength: {
      ...createComputedObjectBinding('minLength'),
    },
  },

  title,
};
</script>
